import { useState } from 'react';
import { Input, message, Modal, Select, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import DropDown from './DropDown';
import { AiFillCloseCircle } from 'react-icons/ai';
import moment from 'moment';
import * as dayjs from 'dayjs'
import { useCreateClient, useGetAllClients } from '../utils/queryUtils';
import { setReloadClient, setReloadFinancialYear } from '../store/action/reload';
import { entityTypes, financialYearTypes, periodTypes } from '../consts';


export default function CreateClient({ visible, setVisible }) {

	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({});
	const { company } = useSelector(st => st.selected);
	const { name: selectedCompany } = company;
	const [showError, setShowError] = useState(false);
	const clientData = useGetAllClients(selectedCompany)
	const [showErrorAbn, setShowErrorAbn] = useState(false);
	const selectedPrimaryClient = useSelector((st) => st.selected.primaryClient || {});
	const [fy, setFy] = useState('');
	const titleInvalidRegex = /[^a-zA-Z0-9 .&()\-]/;
	const abnInvalidRegex = /[^a-zA-Z0-9 ]/;
	const { mutateAsync: createClient } = useCreateClient()
	async function submit() {
		setLoading(true);
		try {
			if (!fy || fy === '') {
				message.error("Add Financial Year")
				return;
			}
			if (data.entity_type === "Other") {
				data.entity_type = data.custom_entity_type;
			}
			if (data.fy_type === "Other") {
				data.fy_type = data.custom_fy_type;
			}
			await createClient({
				company_name: selectedCompany,
				title: data.title,
				abn: data.abn,
				fy: moment(fy, 'YYYY').year(),
				entity_type: data.entity_type,
				fy_type: data.fy_type,
				period_type: data.period_type,
				primary_client: selectedPrimaryClient?._id
			});
			message.success('Entity added successfully');
			dispatch(setReloadFinancialYear(true));
			dispatch(setReloadClient(true));
			clientData.refetch();
			handleClose();
		}
		catch (error) {
			const resp = error?.response?.data;
			let text = "Failed to create entity";
			if (resp) {
				if (resp.errors && Array.isArray(resp.errors) && resp.errors.length) {
					text = resp.errors.map(e => e.msg || e.message || JSON.stringify(e)).join(', ');
				} else if (resp.message) {
					text = resp.message;
				} else if (resp.response) {
					text = resp.response;
				}
			}
			message.error(text);
		} finally {
			setLoading(false);
		}
	}

	const handleClose = () => {
		setVisible(false);
		setFy('');
		setData({ title: '', abn: '' });
	};
	const validateName = (val) => {
		console.log(val)
		if (!titleInvalidRegex.test(val)) {
				setData(pre => ({ ...pre, title: val }))
				setShowError(false);
			}
			else {
				setShowError(true);
			}

	}
	const validateAbnId = (val) => {
		if (!abnInvalidRegex.test(val)) {
				setData(pre => ({ ...pre, abn: val }))
				setShowErrorAbn(false);
			}
			else {
				setShowErrorAbn(true);
			}
	}
	return (
		<Modal
			open={visible}
			onCancel={handleClose}
			title={<h6 className="font-semibold m-0">Add new Entity</h6>}
			okText="Add Entity" onOk={submit}
			destroyOnClose
			okButtonProps={{ loading: loading }}
		>
			<label>Entity Name</label>
			<Input onChange={(ev) => validateName(ev.target.value)} value={data.title} />
			{showError ? <span style={{ color: "red", marginTop: 1, marginBottom: 3, fontSize: "12px" }}>Allowed characters: letters, numbers, spaces, dots (.), hyphens (-), ampersands (&) and parentheses ()
				<br></br></span> : ''}
			<label>ABN ID</label>
			<Input onChange={(ev) => validateAbnId(ev.target.value)} value={data.abn} />
			{showErrorAbn ? <span style={{ color: "red", marginTop: 1, marginBottom: 3, fontSize: "12px" }}>Allowed characters: letters, numbers and spaces
				<br></br></span> : ''}
			<label>Entity Type</label>
			<Select
				className="mb-2"
				style={{ width: '100%' }}
				placeholder="Select Entity Type"
				value={data.entity_type}
				onChange={(value) => setData((prev) => ({ ...prev, entity_type: value, custom_entity_type: '' }))}
			>
				{entityTypes.map((type, i) => (
					<Select.Option key={`entity-type-${i}`} value={type}>
						{type}
					</Select.Option>
				))}
			</Select>
			{data.entity_type === 'Other' && (
				<>
					<Input
						className="mb-3"
						placeholder="Enter your entity type"
						value={data.custom_entity_type}
						onChange={(e) => setData((prev) => ({ ...prev, custom_entity_type: e.target.value }))}
					/>
				</>
			)}


			<label>Financial Year Type</label>
			<Select
				className="mb-2"
				style={{ width: '100%' }}
				placeholder="Select Financial Year Type"
				value={data.fy_type}
				onChange={(value) => setData((prev) => ({ ...prev, fy_type: value, custom_fy_type: '' }))}
			>
				{financialYearTypes.map((type, i) => (
					<Select.Option key={`financial-year-type-${i}`} value={type}>
						{type}
					</Select.Option>
				))}
			</Select>
			{data.fy_type === 'Other' && (
				<>
					<Input
						className="mb-3"
						placeholder="Enter your financial year type"
						value={data.custom_fy_type}
						onChange={(e) => setData((prev) => ({ ...prev, custom_fy_type: e.target.value }))}
					/>
				</>
			)}
			<label>Period Type</label>
			<Select
				className="mb-2"
				style={{ width: '100%' }}
				placeholder="Select Period Type"
				value={data.period_type}
				onChange={(value) => setData((prev) => ({ ...prev, period_type: value }))}
			>
				{periodTypes.map((type, i) => (
					<Select.Option key={`period-type-${i}`} value={type}>
						{type}
					</Select.Option>
				))}
			</Select>


			{fy ?
				<Typography.Text className='d-flex justify-content-between'>
					<span><strong>Financial Year: </strong> {dayjs(fy).subtract(1, 'year').format('YYYY')} -{dayjs(fy).format('YY')}</span>
					<AiFillCloseCircle onClick={() => setFy('')} />
				</Typography.Text> :
				<DropDown canSubmit={false} returnSelected={(e) => { console.log(e); setFy(e) }} style={{ marginTop: "20px" }} />
			}
		</Modal>
	);
}
